
export default {
  name: 'MegasredaRecomendedAuthorBlocksMaterialsCard',
  props: {
    material: {
      type: Object,
      default: null,
    },
  },
  computed: {
    title() {
      return this.material?.title
        ? this.material.title
        : this.material?.description
    },
  },
}
